import React, { forwardRef } from "react";

import { Box, Input, InputGroup, InputLeftElement } from "@chakra-ui/react";

import { format } from "date-fns";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { Controller, useFormContext } from "react-hook-form";
import { FiCalendar } from "react-icons/fi";

export interface FormDatePickerProps {
  name: string;
  placeholderText?: string;
  size?: "sm" | "md" | "lg";
  isClearable?: boolean;
}

// Custom input with calendar icon
const CalendarInput = forwardRef<
  HTMLInputElement,
  {
    value?: string;
    onClick?: () => void;
    onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
    isInvalid?: boolean;
    placeholder?: string;
    size?: "sm" | "md" | "lg";
  }
>(({ value, onClick, onChange, isInvalid, placeholder, size = "md" }, ref) => (
  <InputGroup>
    <InputLeftElement top={size === "sm" ? -1 : 0} pointerEvents="none">
      <FiCalendar />
    </InputLeftElement>
    <Input
      ref={ref}
      value={value}
      rounded={8}
      onClick={onClick}
      onChange={onChange}
      placeholder={placeholder}
      isInvalid={isInvalid}
      size={size}
    />
  </InputGroup>
));

export const FormDatePicker: React.FC<FormDatePickerProps> = ({
  name,
  placeholderText,
  ...props
}) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <Box position="relative" bg="white">
          <DatePicker
            ref={(elem: any) => {
              if (elem) {
                field.ref(elem.input);
              }
            }}
            customInput={
              <CalendarInput isInvalid={!!fieldState.error} size={props.size} />
            }
            wrapperClassName={fieldState.error && "invalid"}
            placeholderText={placeholderText ?? "Choose Date"}
            selected={field.value}
            dateFormat="dd/MM/yyyy"
            onChange={(date: Date | null) =>
              field.onChange(date ? format(date, "yyyy-MM-dd") : null)
            }
            {...props}
          />
        </Box>
      )}
    />
  );
};
